/** @jsx jsx */
import React, { useState } from "react";
import { css, jsx } from "@emotion/core";
import TextForm from "components/molecules/TextForm";
import { RecorderButton, ICCardConnectButton } from "components/atoms/Button";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { grayScale, customButtonColor } from "components/styles";
import BodyText from "components/atoms/BodyText";
import Modal from "components/molecules/Modal";
import useToastNotification from "hooks/useToastNotification";
import useICCardRecorder from "./hooks";
import moment from "moment";
import Icon from 'components/atoms/Icon';

const styles = {
  formRecorder: css({
    textAlign: "center",
  }),
  dateForm: css({
    width: "420px",
    margin: "auto",
  }),
  formContainer: css({
    marginTop: "15px",
    borderRadius: "3px",
    paddingBottom: "50px",
  }),
  imageButton: css({
    width: "100%",
    textAlign: 'center',
    height: '80px',
  }),
  icContainer: css({
    width: '600px',
    height: '335px',
    margin: 'auto',
    border: '1px solid #DCDCDC',
    paddingTop: '10px',
    position: 'relative'
  }),
  icButton: css({
    position: 'absolute',
    top: '10px',
    right: '10px',  
  }),
};

const inputForm = css`
  width: 450px;
  margin: auto;
  justify-content: space-between;
`;

const timeCss = css`
  align-items: baseline;
  justify-content: space-between;
  margin: auto;
  width: 430px;
  color: red;
  line-height: 120px;
  span:first-of-type {
    font-size: 128px;
    color: ${grayScale.gray100};
  }
  span:last-of-type {
    font-size: 32px;
    color: ${grayScale.gray100};
  }
`;
const btnContainer = css`
  flex-wrap: wrap;
  width: 700px;
  justify-content: space-between;
  margin: 30px auto 30px auto;
  height: auto;
  button {
    border-radius: 3px;
    border: 0;
    height: 120px;
    font-size: 24px;
    height: 120px;
    margin-bottom: 20px;
  }
  button:hover {
    opacity: 0.9;
  }
`;

const tableModal = css`
  border-collapse: collapse;
  font-size: 14px;
  tr th {
    color: #999999;
    padding-right: 50px;
    position: relative;
    border-right: 1px solid #dcdcdc;
  }
  tr:not(:last-child) {
    th,
    td {
      padding-bottom: 35px;
    }
  }
  tr td {
    padding-left: 30px;
  }
  margin: 20px auto;
`;
const ICCardRecorder: React.FC<{
  dataTimes: any;
  dataSettings: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  disabledRecorder: boolean;
  fetchHistoryData: any;
}> = ({
  dataTimes,
  dataSettings,
  setIsLoading,
  disabledRecorder,
  fetchHistoryData,
}) => {
  const { errorNotification } = useToastNotification();
  const {
    formik,
    formikConfirm,
    isConfirm,
    staffName,
    lastStampType,
    handleRecorder,
    businessName,
    stampType,
    newUiRemote,
    isConnectUsb,
    setIsConnectUsb,
    detectCard,
    disabledICCard,
    isConnectICCardUsb
  } = useICCardRecorder(
    dataTimes.resultCurrentTime,
    setIsLoading,
    fetchHistoryData
  );

  return (
    <React.Fragment>
      <div css={styles.formContainer}>
        {!dataTimes.currentDay && (
          <div
            style={{
              fontSize: "80px",
              textAlign: "center",
              marginBottom: "70px",
            }}
          >
            サーバ時間取得中・・・
          </div>
        )}

        <FlexBox customStyle={styles.dateForm}>
          <BodyText size="lg" color={grayScale.gray100}>
            {dataTimes.currentDay}
          </BodyText>
        </FlexBox>
        <FlexBox customStyle={timeCss}>
          <BodyText>{dataTimes.timeNow}</BodyText>
          <BodyText>{dataTimes.second}</BodyText>
        </FlexBox>

        {!isConfirm && (
          <div css={styles.icContainer}>
            <FlexBox justifyContent="center">              
              <FlexBoxItem><Icon type="iCCard" color="" size="250px 280px"/></FlexBoxItem>
              <FlexBoxItem customStyle={styles.icButton}>
                <ICCardConnectButton
                  disabled={isConnectICCardUsb}
                  onClick={() => {
                    detectCard();
                  }}
                />
              </FlexBoxItem>
            </FlexBox>
            <FlexBox justifyContent="center">
              <BodyText bold={true} size="re" customStyle={css({paddingTop: '10px', textAlign: 'center'})} >
                {
                  isConnectICCardUsb 
                    ? "カードリーダにカードをかざしてください" 
                    : <React.Fragment>
                        カードリーダーが接続されていません<br/>
                        「Pasoriと接続」ボタンを押して、接続してください。
                      </React.Fragment>

                }
              </BodyText>
            </FlexBox>
          </div>
        )}
        {isConfirm && (
          <div style={{ width: "100%", textAlign: "center" }}>
            <BodyText color={grayScale.gray100} size="xxl" bold={true}>
              {staffName}
              {
                (lastStampType === -1 || lastStampType === 3) && "さん、出勤打刻を押してください。"
              }
              {
                (lastStampType === 0 || lastStampType === 2) && "さん、退勤打刻または休憩開始を押してください。"
              }
              {
                lastStampType === 1 && "さん、休憩終了を押してください。"
              }
            </BodyText>
          </div>
        )}

        {/* <FlexBoxItem basis="48%">
        <PrimaryButton
          text="出勤"
          onClick={() => {}}
          fullwidth={true}
          customStyle={css({
            backgroundColor: customButtonColor.green,
            "&:hover,&:focus": css({
              backgroundColor: customButtonColor.green,
            }),
          })}
        />
      </FlexBoxItem> */}
        {isConfirm && (
          <React.Fragment>
            <FlexBox customStyle={btnContainer}>
              {(lastStampType === -1 || lastStampType === 3) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="登園"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}
              {/* {(lastStampType === -1 || lastStampType === 3) && !newUiRemote && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="出勤"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}

              {(lastStampType === -1 || lastStampType === 3) && newUiRemote && (
                <React.Fragment>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="オフィス出勤"
                      onClick={() => handleRecorder(0)}
                      icon="checkInOffice"
                      background="#007BC3"
                    />
                  </FlexBoxItem>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="テレワーク出勤"
                      onClick={() => handleRecorder(0, undefined, undefined, true)}
                      icon="checkInRemote"
                      background="#F8BF2D"
                    />
                  </FlexBoxItem>
                </React.Fragment>
              )} */}

              {(lastStampType === 0 || lastStampType === 2) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="退園"
                    onClick={() => handleRecorder(3)}
                    icon="checkOut"
                    background="#666666"
                  />
                </FlexBoxItem>
              )}

              {/* {(lastStampType === 0 || lastStampType === 2) && (
                <RecorderButton
                  text="休憩開始"
                  onClick={() => handleRecorder(1)}
                  icon="breakStart"
                  background="#00B172"
                />
              )}

              {lastStampType === 1 && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="休憩終了"
                    onClick={() => handleRecorder(2)}
                    icon="breakEnd"
                    background="#8B2E9C"
                  />
                </FlexBoxItem>
              )} */}
            </FlexBox>
          </React.Fragment>
        )}
      </div>
      {/* <Modal
        open={openModal}
        closeHandler={() => setOpenModal(false)}
        title="打刻完了"
        submitText="閉じる"
        closeText=""
        onSubmit={() => formikConfirm.submitForm()}
        note="以下の内容で打刻しました"
      >
        <table css={tableModal}>
          <tbody>
          <tr>
            <th>氏名</th>
            <td>{formikConfirm.values.staffName}</td>
          </tr>
          <tr>
            <th>日付</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "YYYY年MM月DD日 (ddd)"
              )}
            </td>
          </tr>
          <tr>
            <th>時間</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "HH:mm:ss"
              )}
            </td>
          </tr>
          <tr>
            <th>打刻</th>
            <td>
              {stampType === 0 && <React.Fragment>出勤</React.Fragment>}
              {stampType === 1 && <React.Fragment>休憩開始</React.Fragment>}
              {stampType === 2 && <React.Fragment>休憩終了</React.Fragment>}
              {stampType === 3 && <React.Fragment>退勤</React.Fragment>}
              {businessName}
            </td>
          </tr>
          </tbody>
        </table>
      </Modal> */}
    </React.Fragment>
  );
};

export default ICCardRecorder;
